var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import Button from '../../../../../Components/ComponentButton';
import Select from 'react-select-search';
import T from '../../../../../Utils/Locale';
const DocumentsSelection = ({ packageInfo, userId, setCurrentStep }) => {
    const [products, setProducts] = useState(Array.from({ length: packageInfo.number_of_products }, (_, i) => ({ id: `select-product-${i}`, value: null })));
    const [isAddLoading, setAddLoading] = useState(false);
    const [error, setError] = useState(null);
    const availableProducts = Array.isArray(packageInfo.products) ? packageInfo.products : Object.values(packageInfo.products);
    const selectOptions = availableProducts.map((product) => ({ name: T(`products.${product}`), value: product }));
    const isSubmitDisabled = products.some(document => document.value == null);
    return (_jsxs("div", { children: [_jsxs("div", Object.assign({ className: 'flex flex-col md:flex-row' }, { children: [_jsx("div", Object.assign({ className: 'flex flex-col md:flex-row' }, { children: products.map((product) => (_jsx("div", Object.assign({ className: 'mt-1 md:mt-3 md:mr-3' }, { children: _jsx(Select, { id: product.id, placeholder: T('dashboard.partnerBanner.selectPlaceholder'), value: product.value, options: selectOptions, onChange: (value) => handleChangeProduct(product.id, value) }) }), product.id))) })), _jsx("div", Object.assign({ className: 'w-full md:w-auto mt-3 md:ml-3' }, { children: _jsx(Button, Object.assign({ id: 'dashboard-add-documents-to-cart', classes: `${isSubmitDisabled ? 'disabled' : ''} w-full md:w-auto`, onClick: handleClickAddDocumentsToBasket, isDisabled: isSubmitDisabled, isLoading: isAddLoading }, { children: T('dashboard.partnerBanner.addToBasketButton') })) }))] })), error != null && _jsx("p", Object.assign({ className: 'mt-2 text-viva-red' }, { children: error }))] }));
    function handleChangeProduct(id, value) {
        let updatedProducts = [];
        products.forEach((product) => {
            if (product.id === id) {
                updatedProducts = [...updatedProducts, Object.assign(Object.assign({}, product), { value })];
            }
            else {
                updatedProducts = [...updatedProducts, product];
            }
        });
        setProducts(updatedProducts);
    }
    function handleClickAddDocumentsToBasket() {
        return __awaiter(this, void 0, void 0, function* () {
            if (isSubmitDisabled || isAddLoading) {
                return;
            }
            let promises = [];
            products.forEach((document) => {
                const promise = axios.post(`/api/basket?user=${userId}&partner=${packageInfo.partner}`, {
                    product: document.value,
                    purchase_type: packageInfo.purchase_types[0]
                });
                promises = [...promises, promise];
            });
            try {
                setAddLoading(true);
                yield Promise.all(promises);
                document.querySelector('#toggle-basket').click();
                setCurrentStep(3);
            }
            catch (_a) {
                setError(T('dashboard.partnerBanner.error'));
            }
            finally {
                setAddLoading(false);
            }
        });
    }
};
DocumentsSelection.propTypes = {
    packageInfo: PropTypes.object.isRequired,
    userId: PropTypes.number.isRequired,
    setCurrentStep: PropTypes.func.isRequired
};
export default DocumentsSelection;
